import * as types from './actionTypes';
import UserLoginAPI from '../services/userLoginAPI';
import User from '../types/User';

export function loadLoggedInUserSuccess(user: User) {
    return { type: types.LOAD_LOGGED_USER_SUCCESS, user};
  }

// Action to clear the logged-in user from Redux
export function logoutUserSuccess() {
    return { type: types.LOGOUT_USER_SUCCESS, user: null };
  }

  export function loadLoggedInUser(loggedInUser: User) {
    return async function (dispatch: any) {
      try {
        if (!loggedInUser) {
          throw new Error("No user found for login.");
        }
 
        dispatch(loadLoggedInUserSuccess(loggedInUser));
      } catch (error) {
        console.error('Error loading logged-in user:', error);
        throw error;
      }
    };
  }
  

// Thunk to log out the user
export function logoutUser() {
    return function (dispatch: any) {
      return dispatch(logoutUserSuccess());
    };
}